import { Row } from "@tanstack/react-table"
import { useModal } from "../../../context/ModalContext"
import { TableRow } from "../table/table"
import { memo, useCallback } from "react"
import {
	TableMovement,
	TableOrder,
} from "../../tables/transactions-table/data/types"

interface TableRowClickableProps<TData> {
	row: Row<TData>
	children: React.ReactNode
	rowHeightClass?: string
	rowClassName?: string
	onRowSelected?: (row: TData) => void
	modalConfig?: {
		enableModal?: boolean
	}
}
export const TableRowClickable = memo(
    <TData extends object>(props: TableRowClickableProps<TData>) => {
        const {
            row,
            children,
            rowHeightClass,
            rowClassName,
            onRowSelected,
            modalConfig,
        } = props
        const { setSelectedItem, setModalOpen } = useModal()

        const handleClick = useCallback(() => {
            if (onRowSelected) {
                onRowSelected(row.original)
            }
            if (modalConfig?.enableModal) {
                setSelectedItem(row.original as TableMovement | TableOrder)
                setModalOpen(true)
            }
            row.toggleSelected(!row.getIsSelected())
        }, [row])

        return (
            <TableRow
                className={`hover:bg-background p-xs group ${rowHeightClass} ${rowClassName}`}
                key={row.id}
                data-state={row.getIsSelected() && "selected"}
                onClick={handleClick}
            >
                {children}
            </TableRow>
        )
    },
    (prevProps, nextProps) => prevProps.row === nextProps.row
)

TableRowClickable.displayName = "TableRowClickable"
